import React from 'react';
import PropTypes from 'prop-types';

const HistoricalDibelsBox = ({ url, classNames }) => (
    <div className={classNames}>
        Historical DIBELS Next data can be viewed in a separate window.{' '}
        <a className="anchor" href={url} target="_blank" rel="noreferrer noopener">
            Click here to view data.
        </a>
    </div>
);

HistoricalDibelsBox.defaultProps = {
    url: '',
    classNames: '',
};

HistoricalDibelsBox.propTypes = {
    url: PropTypes.string,
    classNames: PropTypes.string,
};

export default HistoricalDibelsBox;
